import * as _ from "lodash"

export const arrayMove = (arr: any[], oldIndex: number, newIndex: number) => {
  const clone = _.cloneDeep(arr)

  if (newIndex >= clone.length) {
    let k = newIndex - clone.length + 1
    while (k--) {
      clone.push(undefined)
    }
  }
  clone.splice(newIndex, 0, clone.splice(oldIndex, 1)[0])
  return _.cloneDeep(clone)
}
